import { cloneDeep } from 'lodash';

// Permission filtering for the menu tree.
//
// Extracted from the sidebar so that anything else offering navigation — the
// command palette — cannot drift from what the sidebar shows. A page reachable
// from one and not the other would be a permission bug.

export const hasReadPermission = (permissions, controller) =>
    !!permissions?.[controller] && permissions[controller].read !== 'deny';

/**
 * Menu tree with entries the user cannot read removed. Groups whose children
 * are all removed drop out too, so no empty group headers survive.
 *
 * Returns [] until permissions have loaded, matching the sidebar: showing an
 * unfiltered menu for a moment would flash pages the user has no access to.
 */
export const filterMenuByPermissions = (menu, permissions) => {
    if (!permissions || !Object.keys(permissions).length) return [];

    const filter = (items) =>
        items.filter((item) => {
            if (!item.controller && !item.sublistData) return true;
            if (item.sublistData) {
                item.sublistData = filter(item.sublistData);
                return item.sublistData.length > 0;
            }
            return hasReadPermission(permissions, item.controller);
        });

    return filter(cloneDeep(menu));
};

/**
 * Navigable leaves of the tree, each carrying the titles of its ancestors so a
 * result can be shown in context ("Account / Users"). Groups themselves are
 * omitted: their path duplicates their first child's.
 */
export const flattenMenuLeaves = (menu = []) => {
    const leaves = [];

    const walk = (items, trail) => {
        items.forEach((item) => {
            if (item.sublistData && item.sublistData.length) {
                walk(item.sublistData, [...trail, item.title]);
                return;
            }
            if (item.path) {
                leaves.push({
                    title: item.title,
                    path: item.path,
                    icon: item.icon,
                    trail
                });
            }
        });
    };

    walk(menu, []);
    return leaves;
};
